import React from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import nl2br from 'react-nl2br';
import Map from '../Map/Map';
import {showCategory} from './utils'
import PreviewImagesBlock from './PreviewImagesBlock';
import {Button} from "../../../../components/Button";
import DaysTable from '../TourDates';

class Tmp3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tourDuration: []
    }
  }

  componentDidMount() {
    this.handlerTime()
  }

  static propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    minPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    maxPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    // priceOnePerson: PropTypes.oneOfType([
    //   PropTypes.string,
    //   PropTypes.number,
    // ]),
    description: PropTypes.string,
    // tourVideos: PropTypes.array,
    tourPhotos: PropTypes.array,
    categoryId: PropTypes.number,
    cityId: PropTypes.number,
    address: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    // showPlayer: PropTypes.func,
    categories: PropTypes.array,
    tourDates: PropTypes.array,
    addToCart: PropTypes.func,
    deleteFromCart: PropTypes.func,
    isInCart: PropTypes.bool,
    // history: PropTypes.object,
    cartError: PropTypes.object,
    user: PropTypes.object
  };


  handlerTime = () => {
    const {tourDates} = this.props;
    const result = [];
    const arrayMinutes = [];

    for(let i = 0; i < tourDates.length; i++) {
      const startTime = tourDates[i].startTime.split(':');
      const endTime = tourDates[i].endTime.split(':');

      const hours = Number(endTime[0]) - Number(startTime[0]);
      const minutes = Number(endTime[1]) - Number(startTime[1]);
      const minutesAll = hours*60 + minutes;

      if (arrayMinutes.indexOf(minutesAll) === -1) {
        arrayMinutes.push(minutesAll);
        result.push({id: i, hour: hours, minute:  minutes});
      }
    }

    function compareHour(hourA, hourB) {
      return hourA.hour - hourB.hour
    }

    result.sort(compareHour);
    this.setState({tourDuration: result})
  };



  render() {
    const {
      id,
      title,
      minPersons,
      maxPersons,
      // priceOnePerson,
      description,
      tourPhotos,
      categoryId,
      cityId,
      address,
      // tourVideos,
      lat,
      lng,
      // showPlayer,
      categories,
      tourDates,
      addToCart,
      deleteFromCart,
      isInCart,
      // history,
      cartError,
      user,
    } = this.props;

    return (
      <div className="tour-page__template template3">
        <h2 className="tour-page__name">{title}</h2>
        <div className="tour-page__header">
          <div className="tour-page__info">
            <div className="tour-page__info-block">
              <span className="tour-page__info-label">Category:</span>
              {showCategory(categories, categoryId)}
            </div>
            <div className="tour-page__time">
              <p className="tour-page__time-duration">Duration:</p>
              <ul className="tour-page__time-list" >
                {
                  this.state.tourDuration.map((item) => {
                    return (
                      <li className="tour-page__time-item" key={item.id}>
                        {item.hour}h {
                          item.minute > 0 ? `${item.minute}m` : null
                        }
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
          {
            user && !user.isAdmin && user.vendorType !== 'tour' ?
              (
                <div className="tour-page__buttons">
                  {
                    isInCart ?
                      <Button
                        className="button__drop"
                        name="Delete from cart"
                        onClick={() => {
                          deleteFromCart(id)
                        }}
                      /> :
                      <Button
                        name="Book now"
                        onClick={() => {
                          addToCart(id, cityId)
                        }}
                      />
                  }
                  {cartError.differentCity && <span className="error-block">{cartError.differentCity}</span>}
                </div>
              ) : null
          }
        </div>
        <PreviewImagesBlock
          images={tourPhotos}
        />
        <div className="tour-page__group">
          <div className="tour-page__description">
            <h3 className="tour-page__title">Description:</h3>
            <p className="tour-page__description-body">{nl2br(description)}</p>
          </div>
          <div className="tour-page__map-wrap">
            <div className="tour-page__map">
              <h3 className="tour-page__title">Address</h3>
              <div className="tour-page__map-address">
                <span>{address}</span>
              </div>
              <Map
                cords={{lat, lng}}
                zoom={8}
              />
            </div>
            <div className="tour-page__info">
              <div className="tour-page__info-block">
                <span className="tour-page__info-label">People amount:</span>
                <span className="tour-page__info-content">{minPersons} - {maxPersons}</span>
              </div>
              {/* <div className="tour-page__info-block tour-page__price"> */}
              {/* <span className="tour-page__info-label">Price:</span> */}
              {/* <span className="tour-page__info-content">$ {priceOnePerson} <span>/ person</span></span> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <DaysTable
          tourDates={tourDates}
        />
        {
          user && !user.isAdmin && user.vendorType !== 'tour' ?
            (
              <div className="tour-page__buttons">
                {cartError.differentCity && <span className="error-block">{cartError.differentCity}</span>}
                {
                  isInCart ?
                    <Button
                      className="button__drop"
                      name="Delete from cart"
                      onClick={() => {
                        deleteFromCart(id)
                      }}
                    /> :
                    <Button
                      name="Book now"
                      onClick={() => {
                        addToCart(id, cityId)
                      }}
                    />
                }
              </div>
            ) : null
        }
      </div>
    )
  }
}

export default withRouter(Tmp3);


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/Tmp3.js